<template>
    <div class="filling-goods-div-c" style="padding: 0px 10px;">
        <!-- <van-nav-bar title="裁切" left-text="返回" left-arrow @click-left="onClickLeft" /> -->
        <div class="tool">
            <div style="display:flex; align-items: center; justify-content: space-between; width:90%">
                <img src="../assets/amllogo.png" alt="Logo">
                <div class="mix-div">当前工序：<span class="gongxu">裁切</span></div>
                <div class="mix-div" v-if="alltype === '裁切'"
                    style="display: flex;align-items: center;justify-content: space-between;width: 6.5rem;">
                    操作员：{{ gongren }}
                    <van-icon v-if="alltype === '裁切'" name="add" size="0.6rem" color="#1989fa" @click="addG()" />
                </div>
                <van-button class="top-button" v-if="alltype === '裁切'" @click="History()"
                    style="margin-right: 20px;">裁切明细</van-button>
                <!-- <van-button class="top-button" v-if="alltype === '裁切'" @click="Comejj()">来料计件</van-button> 先隐藏-->
                <div style="display: flex; justify-content: flex-end;align-items: center; margin: 10px;"
                    v-if="alltype === '明细'">
                    <van-button type="info" :class="{ 'selected-row': selectedNum === index }"
                        v-for="(i, index) in workerNum" :key="index" @click="selectedN(index)"
                        style="margin-right: 20px;">
                        {{ i.name }}
                    </van-button>
                    <!-- <div style="margin-right: 20px;">总计：{{ dataW.length }}件</div> -->
                </div>
            </div>
            <div class="layui-btn" @click="onClickLeft()">退出</div>
        </div>
        <div class="filling-goods-head-p" :class="{ 'hidden': keyboardOpen }" v-if="alltype === '裁切'">
            <div style="width: 78%;">
                <div style="display: flex; width: 100%; align-items: center;">
                    <div class="corp-head-div">
                        <div class="head-input-div-i">
                            <div style="font-size: 0.48rem; width: 30%; text-align: left;">卷号:</div>
                            <div style="display: flex; flex-wrap: wrap;">
                                <input id="reel-input"
                                    style="height: 0.8rem; width: 3.5rem; font-size: 0.44rem; padding-left: 5px;"
                                    placeholder="请扫描面料码" @keyup.enter="getOrder()" ref="getIDInpot" v-model="reeldata"
                                    v-on:blur="hideMessage('reeldata')" readonly autocomplete="off" />
                            </div>
                        </div>
                        <div class="head-input-div-i">
                            <div style="font-size: 0.48rem; width: 30%; text-align: left;">明细码:</div>
                            <div style="display: flex; flex-wrap: wrap;">
                                <input id="reel-input"
                                    style="height: 0.8rem; width: 3.5rem; font-size: 0.44rem; padding-left: 5px;"
                                    placeholder="请扫描明细码" @keyup.enter="getGck()" ref="getGCKInpot" v-model="Gck"
                                    v-on:blur="hideMessage('Gck')" readonly autocomplete="off" />
                            </div>
                        </div>
                    </div>
                    <div class="corp-head-div">
                        <div class="head-input-div-c">
                            <div style="width: 100%; text-align: left;font-size: 0.44rem;">供应商:{{ supplier_xh }}</div>
                            <div style="width: 100%; text-align: left;font-size: 0.44rem;">型号:{{ goodsnumber }}</div>
                        </div>
                        <div class="head-input-div-c">
                            <div style="width: 100%; text-align: left;font-size: 0.44rem;">门幅:{{ menfu }}</div>
                            <div style="width: 100%; text-align: left;font-size: 0.44rem;">现存量:{{ count }}</div>
                        </div>
                        <div class="head-input-div-c">
                            <!-- <div style="width: 100%; text-align: left;font-size: 0.44rem;">人员:{{ gongren }} </div>
                    <van-icon name="add" size="0.6rem" color="#1989fa" @click="addG()" /> -->
                            <div style="font-size: 0.44rem; width: 100%; text-align: left;">订单米数: {{ orderMeter }}</div>
                        </div>
                    </div>
                    <div class="corp-head-div-t"><!-- 键盘输入米数-->
                        <div style="width: 100%;">
                            <div :class="borderClass"
                                style="display: flex;align-items: center;justify-content: flex-start; margin-bottom: 10px">
                                <input class="Cqday" v-model="inputCq" readonly="readonly" style="height: 86px;" />
                            </div>
                            <div style="display: flex;align-items: center;justify-content: flex-start;">
                                <input class="cutMeter" v-model="inputMeter" readonly="readonly"
                                    style="height: 96px;" />
                            </div>
                        </div>
                    </div>
                </div>
                <div style="width: 100%;">
                    <!-- <div :style="style"> -->
                    <div style="display: flex; align-items: center;">
                        <van-button :type="activeTab === 1 ? 'warning' : 'default'" @click="change(1)"
                            class="left-button">
                            订单
                        </van-button>
                        <van-button :type="activeTab === 2 ? 'warning' : 'default'" @click="change(2)"
                            class="left-button">
                            库存
                        </van-button>
                        <van-button :type="activeTab === 3 ? 'warning' : 'default'" @click="change(3)"
                            class="left-button">
                            余料
                        </van-button>
                        <van-button :type="activeTab === 4 ? 'warning' : 'default'" @click="change(4)"
                            class="left-button">
                            匹配
                        </van-button>
                        <!-- <span style="color: red" v-if="hostcs">测试服</span> -->
                        <div style="color: white;margin-right: 15px; font-size: 20px;">今日完成：{{ cj_num }}</div>
                        <div style="color: white;margin-right: 15px; font-size: 20px;">标准量：{{ standard }}套/天</div>
                        <div style="color: white;margin-right: 15px; font-size: 20px;">完成率：{{ rate }}</div>
                    </div>
                    <div class="table-wrapper" :style="style" v-if="infoType === '1'">
                        <table class="table">
                            <thead>
                                <tr class="table-header">
                                    <th>序号</th>
                                    <th>订单日期</th>
                                    <th>品牌</th>
                                    <th>明细码</th>
                                    <th>主布</th>
                                    <th>配一</th>
                                    <!-- <th>每片用料</th> -->
                                    <th>总用料</th>
                                    <th>裁剪标准</th>
                                    <th>宽度</th>
                                    <th>高度</th>
                                    <th>房称</th>
                                </tr>
                            </thead>
                            <tbody style="overflow:scroll;margin-top: 50px">
                                <tr v-for="(i, index) in data" :key="index" @click="selected(index)"
                                    v-if="i.cut_status !== '已裁切'" :class="{ 'selected-item': selectedIndex === index }">
                                    <td>
                                        {{ index + 1 }}
                                    </td>
                                    <td>
                                        {{ i.order_time.split(' ')[0] }}
                                    </td>
                                    <td>
                                        {{ i.webname }}
                                    </td>
                                    <td>
                                        {{ i.gck_number }}
                                    </td>
                                    <td>
                                        {{ i.zb }}
                                    </td>
                                    <td>
                                        {{ i.py ? i.py : '无' }}
                                    </td>
                                    <td>
                                        {{ i.zb == goodsnumber ? i.zb_ql_num : i.pb_ql_num }}
                                    </td>
                                    <!-- <td>
                                {{ i.ms.裁剪方式 }}
                            </td> -->
                                    <td>
                                        {{ i.value }}
                                    </td>
                                    <td>
                                        {{ getFourValue(i.goods_normtype) }}
                                    </td>
                                    <td>
                                        {{ getFiveValue(i.goods_normtype) }}
                                    </td>
                                    <td>
                                        {{ getSixValue(i.goods_normtype) }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="table-wrapper" :style="style" v-else-if="infoType === '2'">
                        <table class="table" style="width: 100%;">
                            <thead>
                                <tr class="table-header">
                                    <th>序号</th>
                                    <th>货号</th>
                                    <th>现存量</th>
                                    <th>卷号</th>
                                    <th>货位</th>
                                    <th>仓库</th>
                                </tr>
                            </thead>
                            <tbody style="overflow:scroll;margin-top: 50px">
                                <tr v-for="(i, index) in dataK" :key="index" @click="selected(index)"
                                    :class="{ 'selected-item': selectedIndex === index }">
                                    <td>
                                        {{ index + 1 }}
                                    </td>
                                    <td>
                                        {{ i.number }}
                                    </td>
                                    <td>
                                        {{ i.store }}
                                    </td>
                                    <td>
                                        {{ i.reel }}
                                    </td>
                                    <td>
                                        {{ i.goods }}
                                    </td>
                                    <td>
                                        {{ i.warehouse }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="table-wrapper" :style="style" v-else-if="infoType === '3'">
                        <table class="table" style="width: 100%;">
                            <thead>
                                <tr class="table-header">
                                    <th>序号</th>
                                    <th>货号</th>
                                    <th>现存量</th>
                                    <th>卷号</th>
                                    <th>门幅</th>
                                    <th>货位</th>
                                    <th>仓库</th>
                                </tr>
                            </thead>
                            <tbody style="overflow:scroll;margin-top: 50px">
                                <tr v-for="(i, index) in dataY" :key="index" @click="selected(index)"
                                    :class="{ 'selected-item': selectedIndex === index }">
                                    <td>
                                        {{ index + 1 }}
                                    </td>
                                    <td>
                                        {{ i.number }}
                                    </td>
                                    <td>
                                        {{ i.store }}
                                    </td>
                                    <td>
                                        {{ i.reel }}
                                    </td>
                                    <td>
                                        {{ i.menfu }}
                                    </td>
                                    <td>
                                        {{ i.goods }}
                                    </td>
                                    <td>
                                        {{ i.warehouse }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="table-wrapper" :style="style" v-else-if="infoType === '4'">
                        <table class="table" style="width: 100%;">
                            <thead>
                                <tr class="table-header">
                                    <th>序号</th>
                                    <th>货号</th>
                                    <th>现存量</th>
                                    <th>状态</th>
                                    <th>卷号</th>
                                    <th>门幅</th>
                                    <th>货位</th>
                                    <th>仓库</th>
                                </tr>
                            </thead>
                            <tbody style="overflow:scroll;margin-top: 50px">
                                <tr v-for="(i, index) in dataP" :key="index"
                                    :class="{ 'selected-item': i.status === '已匹配' }">
                                    <td>
                                        {{ index + 1 }}
                                    </td>
                                    <td>
                                        {{ i.number }}
                                    </td>
                                    <td>
                                        {{ i.store }}
                                    </td>
                                    <td>
                                        {{ i.status }}
                                    </td>
                                    <td>
                                        {{ i.reel }}
                                    </td>
                                    <td>
                                        {{ i.menfu }}
                                    </td>
                                    <td>
                                        {{ i.goods }}
                                    </td>
                                    <td>
                                        {{ i.warehouse }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!-- </div> -->
                </div>
            </div>
            <div style="width: 20%; height: 100%;">
                <div class="corp-head-div-t">
                    <div class="keyboard">
                        <div v-for="i in 9" :key="i" class="key" @click="addToInput(i)">{{ i }}</div>
                        <div class="key" @click="addToInput(0)">0</div>
                        <div class="key" @click="addToInput('.')">.</div>
                        <div class="key" @click="deleteLastCharacter()">删除</div>
                    </div>
                </div>
                <div class="crop-bottom">
                    <van-button type="info" class="out-button" @click="ConfirmCrop()">确认裁切</van-button>
                    <van-button type="warning" class="out-button" @click="go_print(1)">打印库存</van-button>
                    <van-button type="info" class="out-button" @click="YLinbound()">布料分裁</van-button>
                    <van-button type="warning" class="out-button" @click="openYl()">余料入库</van-button>
                    <van-button type="info" class="out-button" @click="scrap()">疵点报废</van-button>
                    <van-button type="warning" class="out-button" @click="resetClick()">刷新</van-button>
                    <van-button type="info" class="out-button" @click="Matching()">匹配余料</van-button>
                    <van-button type="warning" class="out-button" @click="other()">其他出库</van-button>
                    <!-- <van-button class="right-button" type="warning" style="width: 10%" @click="more_show = true">
                    +
                </van-button> -->
                </div>
            </div>
        </div>
        <div class="filling-goods-head-m" :class="{ 'hidden': keyboardOpen }" v-else-if="alltype === '明细'">
            <div style="display: flex; align-items: center; padding: 10px 0;">
                <el-select v-model="khStatus" filterable placeholder="请选择客户" style="margin-right: 20px;">
                    <el-option v-for="(item, index) in khList" :key="index" :label="item" :value="item">
                    </el-option>
                </el-select>
                <div style="margin-right: 20px;">
                    <el-date-picker v-model="value1" type="daterange" range-separator="至" start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </div>
                <div style="display: flex; align-items: center; margin-right: 20px;">
                    <van-button class="find-button" @click="find()" style="margin-right: 20px;">查询</van-button>
                    <van-button class="find-button-b" @click="goback()">返回</van-button>
                </div>
                <div
                    style="display: flex; align-items: center; color: white;width: 600px; justify-content: space-between;">
                    <div>裁切米数：{{ totalNums }}</div>
                    <div>裁切工费：{{ totalWages }}</div>
                    <div>裁切数量：{{ totalCount }}</div>
                </div>
            </div>
            <div style="width: 100%; padding: 15px 0;">
                <div class="table-wrapper" :style="style3">
                    <table class="table2" style="width: 130%;">
                        <thead>
                            <tr class="table-header">
                                <th>序号</th>
                                <th>裁切日期</th>
                                <th>明细码</th>
                                <th>型号</th>
                                <th>客户</th>
                                <th>工价</th>
                                <th>裁切米数</th>
                                <th>工费</th>
                                <th>卷号</th>
                                <th>确单日期</th>
                                <th>验布时间</th>
                                <!-- <th>是否到货裁切</th>-->
                            </tr>
                        </thead>
                        <tbody style="overflow:scroll;margin-top: 50px">
                            <tr v-for="(i, index) in dataW" :key="index">
                                <td>
                                    {{ index + 1 }}
                                </td>
                                <td>
                                    {{ i.time }}
                                </td>
                                <td>
                                    {{ i.number }}
                                </td>
                                <td>
                                    {{ i.goods_number }}
                                </td>
                                <td>
                                    {{ i.order_shop }}
                                </td>
                                <td>
                                    {{ i.price }}
                                </td>
                                <td>
                                    {{ i.nums }}
                                </td>
                                <td>
                                    {{ i.wages }}
                                </td>
                                <td>
                                    {{ i.reel }}
                                </td>
                                <td>
                                    {{ i.affirm_time }}
                                </td>
                                <td>
                                    {{ i.jy_time }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div style="width: 100%;text-align: center;margin-top: 10px; display: flex; justify-content: center;">
                    <van-pagination v-model="currentPage" :total-items="totalItems" :items-per-page="per_page"
                        @change="pagechange" style="width: 400px;" />
                </div>

                <!-- </div> -->
            </div>
        </div>
        <div class="loading-wrap" v-show="showLoading">
            <div class="loading-mask"></div>
            <div class="loading-content">
                <van-loading color="#000" size="50px" />
            </div>
        </div>
        <!-- 工人 -->
        <van-popup v-model="show_gr" style="padding: 20px; ">
            <div>添加工人</div>
            <div style="display: flex; align-items: center; flex-wrap: wrap; width: 6rem;">
                <div class="popup-input-div" ref="ghContainer">
                    <div style="font-size: 0.48rem; width: 30%; text-align: left;">工号:</div>
                    <div style="display: flex; flex-wrap: wrap;">
                        <input id="gh-input"
                            style="height: 0.8rem; width: 3rem; font-size: 0.48rem; margin: 0 10px; padding: 2px 5px;" />
                    </div>
                </div>
                <van-icon name="add" size="0.6rem" color="#1989fa" @click="addGh()" style="padding-bottom: 10px;" />
            </div>
            <van-button type="info" class="right-button" @click="go_add()">提交</van-button>
        </van-popup>
        <!-- 来料 -->
        <van-popup v-model="show_jj" style="padding: 20px; width: 8rem; height: 4rem;">
            <div style="display: flex;">
                <div style="width: 100%;">来料裁切计件</div>
                <div style="text-align: right;">
                    <van-icon name="cross" @click="closepopup()" style="margin: 5px 5px 0 0" size="22px" />
                </div>
            </div>
            <div style="display: flex; align-items: center; flex-wrap: wrap; width: 100%">
                <div style=" display: flex; width: 100%; align-items: center; justify-content: center; margin: 30px;">
                    <div style="font-size: 0.48rem; width: 30%; text-align: left;">明细码:</div>
                    <div style="display: flex; flex-wrap: wrap;">
                        <input v-model="jjMx" ref="getMXInput" @keyup.enter="getjj()"
                            style="height: 0.8rem; width: 3rem; font-size: 0.48rem; margin: 0 10px; padding: 2px 5px;" />
                    </div>
                </div>
            </div>
            <div><strong>
                    <div :style="{ color: textColor }">{{ warnTips }}</div>
                </strong></div>
        </van-popup>
        <!-- 余料 -->
        <van-popup v-model="show_yl" style="padding: 20px; width: 10rem; height: 6rem;">
            <div style="display: flex; margin-bottom: 20px;">
                <div style="width: 100%;">余料入库</div>
                <div style="text-align: right;">
                    <van-icon name="cross" @click="closepopup()" style="margin: 5px 5px 0 0" size="22px" />
                </div>
            </div>
            <div style="display: flex; align-items: center; flex-wrap: wrap; width: 100%">
                <div style="display: flex; align-items: center; width: 100%; justify-content: space-evenly;">
                    <div>
                        <div style="font-size: 0.42rem; text-align: left; margin: 20px;">卷号: {{ reeldata }} </div>
                        <div style="font-size: 0.42rem; text-align: left; margin: 20px;">型号: {{ goodsnumber }}</div>
                        <div style="font-size: 0.42rem; text-align: left; margin: 20px;">门幅:
                            <input v-model="Ylmenfu" @focus="setFocusedInput('Ylmenfu')" readonly
                                style="height: 0.8rem; width: 2rem; font-size: 0.48rem; margin: 0 10px; padding: 2px 5px;" />
                        </div>
                        <div style="font-size: 0.42rem; text-align: left; margin: 20px;">米数:
                            <input v-model="Ylmeter" @focus="setFocusedInput('Ylmeter')" readonly
                                style="height: 0.8rem; width: 2rem; font-size: 0.48rem; margin: 0 10px; padding: 2px 5px;" />
                        </div>
                    </div>
                    <div class="corp-head-div-t"><!-- 键盘输入米数-->
                        <div class="keyboard">
                            <div v-for="i in 9" :key="i" class="key" @click="addToInput(i)">{{ i }}</div>
                            <div class="key" @click="addToInput(0)">0</div>
                            <div class="key" @click="addToInput('.')">.</div>
                            <div class="key" @click="deleteLastCharacter()">删除</div>
                        </div>
                    </div>
                </div>
                <van-button type="info" class="right-button" style="width: 100%;" @click="go_rk()">入库</van-button>
            </div>
        </van-popup>
        <!-- 匹配余料 -->
        <van-popup v-model="show_Matching" style="padding: 20px; width: 9rem; height: 4rem; overflow-y: hidden;"
            :lock-scroll="false" :close-on-click-overlay="false">
            <div style="display: flex; margin-bottom: 20px;">
                <div style="width: 100%;">匹配余料</div>
                <div style="text-align: right;">
                    <van-icon name="cross" @click="closepopup()" style="margin: 5px 5px 0 0" size="22px" />
                </div>
            </div>
            <div style="display: flex; align-items: center; flex-wrap: wrap; width: 100%">
                <div style=" display: flex; width: 100%; align-items: center; justify-content: center; margin: 30px;">
                    <div style="font-size: 0.48rem; width: 30%; text-align: left;">余料卷号:</div>
                    <div style="display: flex; flex-wrap: wrap;">
                        <input v-model="MatchingYL" ref="getMatching" @keyup.enter="MatchingGet()"
                            style="height: 0.8rem; width: 4rem; font-size: 0.48rem; margin: 0 10px; padding: 2px 5px;" />
                    </div>
                </div>
            </div>
            <div><strong>
                    <div :style="{ color: textColor }">{{ warnTips }}</div>
                </strong></div>
        </van-popup>
        <!-- 其他出库 -->
        <van-popup v-model="Other_out" style="padding: 20px; width: 9rem; height: 3rem; overflow-y: hidden;"
            :lock-scroll="false" :close-on-click-overlay="false">
            <div style="display: flex; margin-bottom: 20px;">
                <div style="width: 100%;">其他出库</div>
                <div style="text-align: right;">
                    <van-icon name="cross" @click="closepopup()" style="margin: 5px 5px 0 0" size="22px" />
                </div>
            </div>
            <div style="display: flex; align-items: center; width: 100%">
                <div
                    style=" display: flex; width: 100%; align-items: center; justify-content: center; margin: 20px; justify-content: space-around;">
                    <van-button type="info" style="width: 25%; height: 60px; line-height: 60px;"
                        @click="outbound('b')">绑带出库</van-button>
                    <van-button type="info" style="width: 25%; height: 60px; line-height: 60px;"
                        @click="outbound('y')">余料出库</van-button>
                    <van-button type="info" style="width: 25%; height: 60px; line-height: 60px;"
                        @click="outbound('l')">帘头出库</van-button>
                    <!-- <div style="font-size: 0.48rem; width: 30%; text-align: left;">绑带出库</div>
                    <div style="font-size: 0.48rem; width: 30%; text-align: left;">余料出库</div>
                    <div style="font-size: 0.48rem; width: 30%; text-align: left;">帘头出库</div> -->
                </div>
            </div>
        </van-popup>
        <!-- 历史记录 -->
        <!-- <van-popup v-model="show_History" style="padding: 20px; width: 15rem; height: 8rem; overflow-y: hidden;"
            :lock-scroll="false" :close-on-click-overlay="false">
            <div style="display: flex; margin-bottom: 20px;">
                <div style="width: 100%;">裁切明细</div>
                <div style="text-align: right;">
                    <van-icon name="cross" @click="closepopup()" style="margin: 5px 5px 0 0" size="22px" />
                </div>
            </div>
            <div style="width: 100%">
                <div style="display: flex; justify-content: flex-end;align-items: center;">
                    <div style="margin-right: 20px;">总计：{{ dataW.length }}件</div>
                    <van-button type="info" :class="{ 'selected': selectedNum === index }"
                        v-for="(i, index) in workerNum" :key="index" @click="selectedN(index)"
                        style="margin-right: 10px;">
                        {{ i.name }}
                    </van-button>
                </div>
                <div class="table-wrapper"
                    style="width: 100%; height: 500px; border: 1px solid #d1d1d1; -webkit-overflow-scrolling: touch;">
                    <table class="table" style="width: 100%;">
                        <thead>
                            <tr class="table-header">
                                <th>序号</th>
                                <th>工序</th>
                                <th>明细码</th>
                                <th>时间</th>
                            </tr>
                        </thead>
                        <tbody style="overflow-y:scroll;margin-top: 50px;-webkit-overflow-scrolling: touch;">
                            <tr v-for="(i, index) in dataW" :key="index" @click="selected(index)"
                                :class="{ 'selected-item': selectedIndex === index }">
                                <td>
                                    {{ index + 1 }}
                                </td>
                                <td>
                                    {{ i.gongyi }}
                                </td>
                                <td>
                                    {{ i.number }}
                                </td>
                                <td>
                                    {{ i.time }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </van-popup> -->
        <!-- <van-loading style="  position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%); z-index: 9999;"
            color="white" v-if="loading" /> -->
    </div>
</template>

<script>
import $ from "jquery";
import { mapState, mapMutations } from "vuex";
import { Dialog, Loading } from "vant";
import { Toast } from "vant";
import moment from 'moment';
// import { NavBar } from 'vant'
import Barcode from '@/components/Barcode';
export default {
    name: "Reelcrop",
    components: {
        Barcode
    },
    data() {
        return {
            hostcs: false,
            more_show: false,
            ray: "扫描中",
            id: "",
            supplier_xh: "",
            count: "",
            goodsnumber: "",
            data: [],
            dataK: [],
            dataY: [],
            dataW: [],
            dataP: [],
            khList: [],
            style: "",
            style2: "",
            style3: "",
            allcount: 0,
            reeldata: "",
            out_num: "",
            infoType: "1",
            gck_number_data_haveAll: {},
            Gck: "",
            jjMx: '',
            isCropProcessing: false,
            revocationType: true,
            outNumber: "未出库",
            username: "",
            type: "orderInfo",
            count: "",
            show_gr: false,
            show_jj: false,
            show_yl: false,
            show_History: false,
            show_Matching: false,
            Other_out: false,
            MatchingYL: '',
            MatchingList: [],
            numList: [],
            keyboardOpen: false,
            selectedIndex: -1,
            meter: false,
            inputMeter: '',
            orderMeter: '',
            showLoading: false,
            loading: false,
            menfu: '',
            Dydata: '',
            gongren: '',
            workerNum: [],
            gonghao: '',
            fencai: '',
            Fcount: '',
            warnTips: '',
            ppTips: '',
            Ylmenfu: '',
            Ylmeter: '',
            focusedInput: 'Ylmenfu',
            textColor: 'red',
            selectedNum: 0,
            activeTab: 1,
            inputCq: '',
            alltype: '裁切',
            value1: '',
            khStatus: '',
            currentPage: 1,
            standard: '',
            cj_num: '',
            y_goods: '',
            rate: 0,
            totalItems: 0, per_page: 0,
            totalNums: '', totalWages: '', totalCount: '',
            borderClass: 'none-border',
            intervalId: null,
        };
    },
    mounted() {
        this.username = JSON.parse(window.localStorage.getItem("userinfo"));
        this.gonghao = window.localStorage.getItem("gonghao") ? window.localStorage.getItem("gonghao") : '';
        this.gongren = window.localStorage.getItem("gongren") ? window.localStorage.getItem("gongren") : '';
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.style =
            "text-align: left;width: 100%;height: " + h * 0.46 + "px; border: 1px solid #d1d1d1";
        this.style2 = "height: " + h * 0.46 + "px;";
        this.style3 =
            "text-align: left;width: 100%;height: " + h * 0.65 + "px; border: 1px solid #d1d1d1";
        setTimeout(() => {
            this.countAll();
            this.process();
            if (this.outNumber === "未出库") {
                this.focus();
            }
        }, 200);
        if (window.location.host.indexOf("cspda") !== -1) {
            this.hostcs = true;
        }
    },
    watch: {
        show_jj(newValue) {
            if (newValue) {
                this.$nextTick(() => {
                    this.$refs.getMXInput.focus();
                });
            }
        },
        show_Matching(newValue) {
            if (newValue) {
                this.$nextTick(() => {
                    this.$refs.getMatching.focus();
                });
            }
        },
    },
    methods: {
        getFourValue(goodsNormType) {  //宽度
            // const parts = goodsSize.split(',');
            // return parts.length >= 4 ? parts[3].trim() : ' '; 
            const match = goodsNormType.match(/成品尺码\(([^)]+)\)/); // 如果匹配成功，返回括号内的内容
            if (match) {
                const matchedValue = parseFloat(match[1].trim()).toFixed(2); // 保留两位小数
                return matchedValue;
            } else {
                return ' '; // 如果没有找到匹配项，则返回''
            }
            // return match ? match[1].trim() : ' '; 
        },
        getFiveValue(goodsNormType) { //高度
            const match = goodsNormType.match(/成品高度\(([^)]+)\)/);
            if (match) {
                const matchedValue = parseFloat(match[1].trim()).toFixed(2);
                return matchedValue;
            } else {
                return ' ';
            }
            //return match ? match[1].trim() : ' '; 
        },
        getSixValue(goodsNormType) {
            const match = goodsNormType.match(/房间名称\(([^)]+)\)/);
            return match ? match[1].trim() : ' ';
        },
        Comejj() {
            this.show_jj = true;
        },
        goback() {
            this.alltype = '裁切';
            this.selectedNum = 0;
            this.khStatus = '';
            this.value1 = '';
            setTimeout(() => {
                this.focus();
            }, 200);

        },
        closepopup() {
            this.show_jj = false;
            this.show_yl = false;
            this.show_History = false;
            this.show_Matching = false;
            this.Other_out = false;
            this.selectedNum = 0;
            this.warnTips = '';
            this.ppTips = '';
            this.Ylmenfu = '';
            this.Ylmeter = '';
        },
        process() {
            var url = window.localStorage.getItem("pdaBASEURL")
            var baseUrl = url.replace('/api', '');
            this.get(baseUrl + '/admin/findProcess', {
                gonghao: this.gonghao,
            }).then((res) => {
                this.standard = res.data.data.num
                this.khList = res.data.data.client
                this.cj_num = res.data.data.cj_num
                if (this.standard != '0') {
                    this.rate = (parseFloat(this.cj_num) / parseFloat(this.standard) * 100).toFixed(2) + '%'
                } else {
                    this.rate = 0;
                }
            });
        },
        getjj() {
            this.loading = true;
            var url = window.localStorage.getItem("pdaBASEURL")
            var baseUrl = url.replace('/api', '');
            this.get(baseUrl + '/admin/doEngineering', {
                process: '裁剪',
                people: this.gonghao,
                number: this.jjMx,
            }).then((res) => {
                var xcolor = res.data.data.status;
                this.loading = false;
                if (xcolor === 'OK') {
                    this.textColor = 'black'
                } else {
                    this.textColor = 'red';
                }
                this.warnTips = res.data.msg;
                this.jjMx = '';
            });
        },
        openYl() {
            this.show_yl = true;
            this.focusedInput = 'Ylmenfu';
        },
        selectedN(index) {
            this.selectedNum = index;
            this.currentPage = 1
            this.khStatus = ''
            this.value1 = ''
            var url = window.localStorage.getItem("pdaBASEURL")
            var baseUrl = url.replace('/api', '');
            this.get(baseUrl + '/admin/allCjMx', { gonghao: this.workerNum[index].num }).then((res) => {
                if (res.data.status == 1) {
                    this.dataW = res.data.data.card.data;
                    this.totalWages = res.data.data.totalWages;
                    this.totalNums = res.data.data.totalNums;
                    this.totalCount = res.data.data.card.total;
                    this.totalItems = res.data.data.card.total;
                } else {
                    Toast('错误')
                }
            });
        },
        find() {
            this.currentPage = 1
            this.pagechange()
        },
        pagechange() {
            if (this.value1) {
                var x = moment(this.value1[0]).format('YYYY-MM-DD HH:mm:ss');
                var y = moment(this.value1[1]).format('YYYY-MM-DD HH:mm:ss');
            } else {
                var x = '';
                var y = '';
            }
            var url = window.localStorage.getItem("pdaBASEURL")
            var baseUrl = url.replace('/api', '');
            this.get(baseUrl + '/admin/allCjMx', {
                gonghao: this.workerNum[this.selectedNum].num,
                page: this.currentPage,
                client: this.khStatus,
                start: x,
                end: y
            }).then((res) => {
                if (res.data.status == 1) {
                    this.dataW = res.data.data.card.data;
                    this.totalWages = res.data.data.totalWages;
                    this.totalNums = res.data.data.totalNums;
                    this.totalCount = res.data.data.card.total;
                    this.totalItems = res.data.data.card.total;
                } else {
                    Toast('错误')
                }
            });
        },
        History() {
            if (this.gonghao == '') {
                Toast('请先登录工号');
                return;
            }
            let gonghaoArray = this.gonghao.split(',');  //处理整合工人工号
            let gongrenArray = this.gongren.split(' ');
            gongrenArray = gongrenArray.filter(item => item !== '');
            this.workerNum = gonghaoArray.map((num, index) => {
                return { num: num, name: gongrenArray[index] };
            });
            //this.show_History = true;
            this.alltype = '明细'
            this.khStatus = '';
            this.value1 = '';
            var url = window.localStorage.getItem("pdaBASEURL")
            var baseUrl = url.replace('/api', '');
            this.get(baseUrl + '/admin/allCjMx', { gonghao: this.workerNum[0].num }).then((res) => {
                if (res.data.status == 1) {
                    this.dataW = res.data.data.card.data;;
                    this.totalItems = res.data.data.card.total;
                    this.per_page = res.data.data.card.per_page;
                    this.totalWages = res.data.data.totalWages;
                    this.totalNums = res.data.data.totalNums;
                    this.totalCount = res.data.data.card.total;
                    this.currentPage = 1
                } else {
                    Toast('错误')
                }
            });
        },
        go_rk() { //余料入库
            if (this.isCropProcessing) {
                return
            }
            if (this.reeldata == '') {
                Toast('请先扫描卷号')
                return
            }
            if (this.gonghao == '') {
                Toast('请先登录工号')
                return
            }
            if (this.Ylmenfu == '' || this.Ylmeter == '') {
                Toast('请输入米数和门幅')
                return
            }
            this.isCropProcessing = true;
            this.get("/business/bjCut", {
                reel: this.reeldata,
                type: '余料门幅',
                num: this.Ylmeter,
                name: this.username,
                bw: '',
                people: this.gonghao,
                menfu: this.Ylmenfu
            }).then(
                (res) => {
                    if (res.data.status == 1) {
                        this.Fcount = this.Ylmeter;
                        this.isCropProcessing = false;
                        this.fencai = res.data.data.reel;
                        this.y_goods = res.data.data.goods;
                        this.show_yl = false;
                        this.Ylmeter = '';
                        this.go_print(3);
                        Toast('完成余料入库')
                    } else {
                        this.isCropProcessing = false;
                        Toast(res.data.msg)
                    }
                }
            );
        },
        ConfirmCrop() {  //裁切
            if (this.isCropProcessing) {
                return
            }
            if (this.reeldata == '') {
                Toast('请先扫描卷号')
                this.focus()
                return
            }
            if (this.gonghao == '') {
                Toast('请先登录工号')
                return
            }
            if (this.Gck == '' || this.Gck == undefined) {
                Toast({
                    message: '还未扫描明细码',
                    style: { 'font-Size': '48px !important' }
                })
                this.gck_input()
                return
            }
            if (this.inputMeter == '' || this.inputMeter == 0) {
                Toast('请输入裁切米数')
                return
            }
            // if (this.inputMeter == '' ) {
            //     Toast('请输入裁切米数')
            //     return
            // }
            this.isCropProcessing = true;
            var i = this.selectedIndex;
            var bw = this.data[i].zb == this.goodsnumber ? '主布' : '配布'
            if (this.numList.length != 0 && this.MatchingList.length != 0) {
                this.get("/business/bjCut", {
                    reel: this.MatchingList.join(',') + (this.inputMeter == '0' ? '' : ',' + this.reeldata),
                    id: this.Gck,
                    type: '正常',
                    num: this.numList.join(',') + (this.inputMeter == '0' ? '' : ',' + this.inputMeter),
                    name: this.username,
                    bw: bw,
                    people: this.gonghao
                }).then(
                    (res) => {
                        if (res.data.status == 1) {
                            this.data[i].cut_status = '已裁切'
                            this.data.splice(i, 1);
                            this.count = this.inputMeter == '0' ? this.count : res.data.data;
                            this.selectedIndex = '';
                            this.inputMeter = '';
                            this.Gck = '';
                            this.isCropProcessing = false;
                            this.cj_num++;
                            this.infoType = '1'
                            this.activeTab = 1
                            this.MatchingList = []
                            this.numList = []
                            this.gck_input();
                            Toast('裁切完成，你已报工计件！')
                        } else {
                            this.isCropProcessing = false;
                            Toast(res.data.msg)
                        }
                    }
                );
            } else {
                this.get("/business/bjCut", {
                    reel: this.reeldata,
                    id: this.Gck,
                    type: '正常',
                    num: this.inputMeter,
                    name: this.username,
                    bw: bw,
                    people: this.gonghao
                }).then(
                    (res) => {
                        if (res.data.status == 1) {
                            this.data[i].cut_status = '已裁切'
                            this.data.splice(i, 1);
                            this.count = res.data.data;
                            this.selectedIndex = '';
                            this.inputMeter = '';
                            this.Gck = '';
                            this.isCropProcessing = false;
                            this.cj_num++;
                            this.MatchingList = []
                            this.numList = []
                            this.gck_input();
                            Toast('裁切完成，你已报工计件！')
                        } else {
                            this.isCropProcessing = false;
                            Toast(res.data.msg)
                        }
                    }
                );
            }
            this.MatchingList = []
            this.numList = []
        },
        YLinbound() {  //分裁入库
            if (this.isCropProcessing) {
                return
            }
            if (this.reeldata == '') {
                Toast('请先扫描卷号')
                return
            }
            if (this.gonghao == '') {
                Toast('请先登录工号')
                return
            }
            if (this.inputMeter == '' || this.inputMeter == 0) {
                Toast('请输入分裁米数')
                return
            }
            this.isCropProcessing = true;
            var num2 = this.inputMeter;
            this.get("/business/bjCut", {
                reel: this.reeldata,
                id: this.Gck,
                type: '余料',
                num: this.inputMeter,
                name: this.username,
                bw: '',
                people: this.gonghao
            }).then(
                (res) => {
                    if (res.data.status == 1) {
                        this.Fcount = this.inputMeter;
                        this.inputMeter = '';
                        this.isCropProcessing = false;
                        this.count = res.data.data.num;
                        this.fencai = res.data.data.reel;
                        this.go_print(2);
                        Toast('完成分裁入库')
                    } else {
                        this.isCropProcessing = false;
                        Toast('失败')
                    }
                }
            );
        },
        scrap() {  //报废
            if (this.isCropProcessing) {
                return
            }
            if (this.reeldata == '') {
                Toast('请先扫描卷号')
                return
            }
            if (this.gonghao == '') {
                Toast('请先登录工号')
                return
            }
            if (this.inputMeter == '' || this.inputMeter == 0) {
                Toast('请输入报废米数')
                return
            }
            this.isCropProcessing = true;
            this.get("/business/bjCut", {
                reel: this.reeldata,
                id: this.Gck,
                type: '报废',
                num: this.inputMeter,
                name: this.username,
                bw: '',  //部位
                people: this.gonghao
            }).then(
                (res) => {
                    if (res.data.status == 1) {
                        this.count = res.data.data;
                        this.inputMeter = '';
                        this.isCropProcessing = false;
                        Toast('疵点报废成功')
                    } else {
                        this.isCropProcessing = false;
                        Toast('失败')
                    }
                }
            );
        },
        selected(i) {
            console.log(i)
            this.selectedIndex = i;
            this.meter = true;
        },
        setFocusedInput(inputName) {
            this.focusedInput = inputName;
        },
        addToInput(value) {
            if (!this.show_yl) {
                if (value === '.' && this.inputMeter.indexOf('.') !== -1) {
                    return; // 如果已经输入小数点，则不再添加
                }
                this.inputMeter += value;
            } else if (this.focusedInput == 'Ylmenfu') {
                if (value === '.' && this.Ylmenfu.indexOf('.') !== -1) {
                    return;
                }
                this.Ylmenfu += value;
            } else if (this.focusedInput == 'Ylmeter') {
                if (value === '.' && this.Ylmeter.indexOf('.') !== -1) {
                    return;
                }
                this.Ylmeter += value;
            }
        },
        deleteLastCharacter() {
            if (!this.show_yl) {
                this.inputMeter = this.inputMeter.slice(0, -1);
            } else if (this.focusedInput == 'Ylmenfu') {
                this.Ylmenfu = this.Ylmenfu.slice(0, -1);
            } else if (this.focusedInput == 'Ylmeter') {
                this.Ylmeter = this.Ylmeter.slice(0, -1);
            }
        },
        resetClick() {
            window.location.reload();
        },
        change(type) {
            if (type == 1) {
                if (this.reeldata) {
                    this.infoType = '1'
                    this.activeTab = 1
                    //this.getOrder()
                    this.gck_input();
                } else {
                    Toast('请先扫描卷号!')
                }
            } else if (type == 2) {
                if (this.reeldata) {
                    this.infoType = '2'
                    this.activeTab = 2
                    this.getNumber()
                } else {
                    Toast('请先扫描卷号!')
                }
            } else if (type == 3) {
                if (this.reeldata) {
                    this.infoType = '3'
                    this.activeTab = 3
                    this.getNumber3()
                } else {
                    Toast('请先扫描卷号!')
                }
            } else if (type == 4) {
                if (this.reeldata && this.Gck) {
                    this.infoType = '4'
                    this.activeTab = 4
                    this.getNumber4()
                } else {
                    Toast('请先扫描卷号和明细码!')
                }
            }
        },
        Matching() {
            if (this.reeldata && this.Gck) {
                this.show_Matching = true;
                this.warnTips = "";
            } else {
                Toast('请先扫描卷号和明细码!')
            }
        },
        MatchingGet() {
            var filteredData = this.dataP.filter(item => item.reel === this.MatchingYL);
            if (filteredData.length !== 0) {
                // 显示提示信息
                filteredData.forEach(item => {
                    item.status = '已匹配';
                });
                const matchedItem = filteredData[0];
                // 从原数组中移除已匹配对象并将其插入到数组顶部
                const index = this.dataP.indexOf(matchedItem);
                if (index > -1) {
                    this.dataP.splice(index, 1);  // 从原位置移除
                }
                this.dataP.unshift(matchedItem);
                this.textColor = 'black'
                Toast('成功!');
                this.MatchingList.push(this.MatchingYL)
                this.numList.push(filteredData[0].store)
                this.MatchingYL = '';
                this.show_Matching = false;
            } else {
                this.textColor = 'red';
                this.MatchingYL = '';
                this.warnTips = '余料不匹配！';
            }
            this.$nextTick(() => {
                this.$refs.getMatching.focus();
            });
        },
        other() {
            if (this.reeldata && this.inputMeter) {
                this.Other_out = true;
            } else {
                Toast('请先扫描卷号和输入米数!')
            }
        },
        outbound(val) {
            if (val == 'b') {
                var type = '绑带出库'
            } else if (val == 'y') {
                var type = '余料出库'
            } else if (val == 'l') {
                var type = '帘头出库'
            }
            if (this.isCropProcessing) {
                return
            }
            if (this.reeldata == '') {
                Toast('请先扫描卷号')
                return
            }
            if (this.gonghao == '') {
                Toast('请先登录工号')
                return
            }
            if (this.inputMeter == '' || this.inputMeter == 0) {
                Toast('请输入出库米数')
                return
            }
            this.isCropProcessing = true;
            this.get("/business/bjCut", {
                reel: this.reeldata,
                id: this.Gck,
                type: type,
                num: this.inputMeter,
                name: this.username,
                bw: '',  //部位
                people: this.gonghao
            }).then(
                (res) => {
                    if (res.data.status == 1) {
                        this.count = res.data.data;
                        this.inputMeter = '';
                        this.isCropProcessing = false;
                        this.closepopup();
                        Toast(type + '成功')
                    } else {
                        this.isCropProcessing = false;
                        Toast('失败')
                    }
                }
            );
        },
        getOrder() {
            // 输入卷号 弹出现存量
            this.MatchingList = []
            this.numList = []
            this.infoType = '1'
            this.showLoading = true;
            this.get("/business/reelOrder", { reel: this.reeldata }).then(
                (res) => {
                    if (res.data.status == 1) {
                        var result = res.data.data;
                        this.data = result.data;
                        const { data, ...filteredData } = result
                        this.Dydata = filteredData;
                        this.supplier_xh = result.supplier_xh;
                        this.goodsnumber = result.norms_ware.number;
                        this.menfu = result.norms_ware.menfu;
                        this.count = result.norms_ware.store;
                        this.gck_input();
                        this.showLoading = false;
                    } else {
                        Toast(res.data.msg);
                        this.showLoading = false;
                    }
                }
            );
        },
        getNumber() {   // 输入卷号 弹出库存
            this.showLoading = true;
            this.get("/business/getStore", { number: this.goodsnumber }).then(
                (res) => {
                    if (res.data.status == 1) {
                        this.dataK = res.data.data;
                        this.gck_input();
                        this.showLoading = false;
                    } else {
                        Toast(res.data.msg);
                        this.showLoading = false;
                    }
                }
            );
        },

        getNumber3() {   // 输入卷号 弹出库存
            this.showLoading = true;
            this.get("/business/getStore", { number: this.goodsnumber, ck: '余料' }).then(
                (res) => {
                    if (res.data.status == 1) {
                        this.dataY = res.data.data;
                        this.gck_input();
                        this.showLoading = false;
                    } else {
                        Toast(res.data.msg);
                        this.showLoading = false;
                    }
                }
            );
        },
        getNumber4() {   // 输入卷号 弹出库存
            this.showLoading = true;
            this.get("/findReelYl", { gck_number: this.Gck, reel: this.reeldata }).then(
                (res) => {
                    if (res.data.status == 1) {
                        this.dataP = res.data.data;
                        //this.gck_input();
                        this.showLoading = false;
                    } else {
                        Toast(res.data.msg);
                        this.showLoading = false;
                        this.change(1)
                    }
                }
            );
        },
        getGck() {
            this.MatchingList = []
            this.numList = []
            this.sData = this.data.filter(item => item.gck_number === this.Gck);
            // 如果没有找到匹配的数据
            if (this.sData.length !== 0) {
                // 显示提示信息
                if (this.sData[0].zb == this.goodsnumber) {
                    this.orderMeter = this.sData[0].zb_ql_num
                } else {
                    this.orderMeter = this.sData[0].pb_ql_num
                }
                this.get("/findReelYl", { gck_number: this.Gck, reel: this.reeldata, type: 'mxm' }).then(
                    (res) => {
                        if (res.data.status == 1) {
                            this.change(4)
                        }
                    }
                );
                this.inputCq = this.sData[0].chaoqi
                if (this.inputCq.indexOf("超期") !== -1) {
                    this.borderClass = 'red-border';
                        // 清除之前的定时器（避免重复设置）
                        if (this.intervalId) {
                            clearInterval(this.intervalId);
                        }
                        // 设置定时器进行边框颜色切换
                        this.intervalId = setInterval(() => {// 切换边框颜色
                            this.borderClass = this.borderClass === 'red-border' ? 'none-border' : 'red-border';
                        }, 1000); // 每1秒切换一次
                } else {
                    // 使用正则表达式匹配连续的数字
                    const regex = /\d+(\.\d+)?/g;
                    const matches = this.inputCq.match(regex);
                    if (matches <= 5) {
                        this.borderClass = 'red-border';
                        // 清除之前的定时器（避免重复设置）
                        if (this.intervalId) {
                            clearInterval(this.intervalId);
                        }
                        // 设置定时器进行边框颜色切换
                        this.intervalId = setInterval(() => {// 切换边框颜色
                            this.borderClass = this.borderClass === 'red-border' ? 'none-border' : 'red-border';
                        }, 1000); // 每1秒切换一次
                    } else {
                        // 如果不满足条件，恢复默认边框
                        this.borderClass = 'none-border';
                        // 清除定时器
                        if (this.intervalId) {
                            clearInterval(this.intervalId);
                            this.intervalId = null; // 重置定时器ID
                        }
                    }
                }
                this.selectedIndex = this.data.indexOf(this.sData[0]);
                this.scrollToSelectedRow()
            } else {
                this.Gck = '';
                Toast('型号与工单信息不一致!');
                this.gck_input();
            }
        },
        scrollToSelectedRow() {
            // 使用 DOM 操作滚动到指定行
            const selectedRowElement = this.$el.querySelector(
                `tbody tr:nth-child(${this.selectedIndex})`
            );
            console.log(selectedRowElement)
            selectedRowElement.scrollIntoView({ behavior: 'smooth' });
        },
        async go_print(index) {
            if (this.Dydata) {
                this.Dydata.count = this.count;
                this.Dydata.type = '';
                if (index == 2) {
                    this.Dydata.Fcount = this.Fcount ? this.Fcount : null;
                    this.Dydata.Freel = this.fencai ? this.fencai : null;
                } else if (index == 3) {
                    this.Dydata.type = '余料入库';
                    this.Dydata.mf = this.Ylmenfu;
                    this.Dydata.y_goods = this.y_goods;
                    this.Ylmenfu = '';
                    this.Dydata.Fcount = this.Fcount ? this.Fcount : null;
                    this.Dydata.Freel = this.fencai ? this.fencai : null;
                } else {
                    this.Dydata.Fcount = null;
                    this.Dydata.Freel = null;
                }
                this.Dydata.people = this.gongren;
                console.log(this.Dydata)
                Android.postMessage(JSON.stringify(this.Dydata));
                await this.dayin();
            }
        },
        dayin() {
            console.log('cjdy');
            this.reeldata = '';
            this.Dydata = '';
            this.focus();
        },
        addG() {
            this.show_gr = true;
        },
        addGh() {
            // 复制整个 ghContainer 元素
            const container = this.$refs.ghContainer;
            const newContainer = container.cloneNode(true);
            container.parentNode.appendChild(newContainer);
        },
        async go_add() {
            // 复制整个 ghContainer 元素
            var ghInputs = document.querySelectorAll('.popup-input-div input[id="gh-input"]');
            var ghData = Array.from(ghInputs).map(input => input.value);
            var newApiUrl = window.localStorage.getItem('pdaBASEURL').replace('/api', '');
            if (ghData.includes('')) {
                Toast('存在空工号，请填写完整');
            } else if (new Set(ghData).size !== ghData.length) {
                Toast('存在重复的工号，请重新填写');
            } else {
                this.gongren = '';
                this.gonghao = '';
                for (var i = 0; i < ghData.length; i++) {
                    await this.get(newApiUrl + "/admin/gongren", { user_id: ghData[i] }).then(
                        (res) => {
                            if (res.data.status == 1) {
                                var result = res.data.data;
                                this.gonghao += (',' + res.data.data.number);
                                this.gongren += (' ' + res.data.data.name);
                                //this.workerNum.push({gonghao:res.data.data.number ,gongren:res.data.data.name})
                                this.show_gr = false;
                                this.focus();
                            } else {
                                this.gongren = '';
                                this.gonghao = '';
                                localStorage.setItem("gonghao", this.gonghao);
                                console.log(ghData[i])
                                Toast(ghData[i] + '工号不存在!');
                                this.focus();
                            }
                        }
                    );
                }
            }
            this.gonghao = this.gonghao.slice(1)
            localStorage.setItem("gonghao", this.gonghao);
            localStorage.setItem("gongren", this.gongren);
            //localStorage.setItem("workerNum", this.workerNum);
        },
        all_delete() {
            if (this.outNumber === "已出库") {
                Toast("已出库不能删除");
                return;
            }
            Dialog.confirm({
                message: "确定要删除当前出库单吗？",
            }).then(async () => {
                let s = await this.get(this.APIOBJ.outDel, {
                    id: this.id,
                    username: this.username,
                });
                Toast(s.data.msg);
                if (s.data.status === 1) {
                    setTimeout(() => {
                        this.$router.push("/home");
                    }, 500);
                }
            });
        },
        keyFocus() {
            this.keyboardOpen = true;
        },
        countAll() {
            //计算总量
            this.keyboardOpen = false;
            this.allcount = 0;
            for (let i of this.data) {
                this.allcount += parseFloat(i["all_num"]);
            }
            this.allcount = this.allcount.toFixed(1);
        },
        hideMessage(title) {
            if (title === "reeldata") {
                if (this.reeldata === "") {
                    this.ray = "已暂停，点击我继续扫码";
                }
            }
            if (title === "Gck") {
                if (this.gck_number_data === "") {
                    this.ray = "已暂停，点击我继续扫码";
                }
            }
        },
        holdRay() {
            this.ray = "扫描中";
            if (this.reeldata === "") {
                this.focus();
            } else if (this.gck_number_data === "") {
                this.gck_input();
            }
        },
        focus() {
            this.$refs.getIDInpot.focus();
            setTimeout(() => {
                this.$refs.getIDInpot.removeAttribute("readonly");
            }, 200);
        },
        gck_input() {
            this.$refs.getGCKInpot.focus();
            this.$refs.getGCKInpot.setAttribute("readonly", "readonly");
            setTimeout(() => {
                this.$refs.getGCKInpot.removeAttribute("readonly");
            }, 200);
        },
        deleteData(index, gck_number_data) {
            if (this.outNumber === "已出库") {
                Toast("已出库不能删除");
                return;
            }
            Dialog.confirm({
                message: "确定要删除该明细吗？",
            }).then(() => {
                let mxm = this.data[index].mxm | this.data[index].gck_number;
                this.data.splice(index, 1);
                delete this.gck_number_data_haveAll[mxm];
                setTimeout(() => {
                    this.countAll();
                }, 0);
            });
        },
        onClickLeft() {
            Dialog.confirm({
                message: "确定要回首页吗？",
            })
                .then(() => {
                    this.$router.push("/home");
                })
                .catch(() => {
                    // on cancel
                });
        },
        async revocation(id) {
            if (!this.revocationType) {
                return;
            }
            this.revocationType = false;
            let out_info = await this.get(this.APIOBJ.backOut, {
                id: id,
                username: this.username,
            });
            this.outNumber = "未出库";
            if (out_info.data.status === 1) {
                Toast("已撤销");
            }
            this.infoType = "1111";
            this.revocationType = true;
        },
    },
};
</script>

<style lang="less">
@import "../style/outOrderInfo.less";

.filling-goods-head-p {
    padding: 10px 0;
    flex-wrap: wrap;
    display: flex;
    border-top: 8px solid #fff;
    /* 上边框 */
    /*border-bottom: 1px solid #000000;*/
    /* 下边框 */
    justify-content: space-between;
    // align-items: center;
    // height: 30%;
    /* overflow: auto; */
    padding: 10px;
}

.filling-goods-head-m {
    padding: 10px 0;
    // flex-wrap: wrap;
    // display: flex;
    border-top: 8px solid #fff;
    justify-content: space-between;
    // align-items: center;
    //height: 715.3px;
    /* overflow: auto; */
    padding: 10px;
}

.filling-goods-div-c {
    background: url(../assets/amlbg.png) center;
    background-repeat: repeat;
    /* 水平和垂直方向平铺 */
    background-size: cover;
}

#app {
    margin: 0 0px;
}

.red-border {
    border: 5px solid red;
    /* 红色边框 */
}
.none-border {
    border: 5px solid #ededed;
    /* 红色边框 */
}
.selected-row {
    background-color: #ff9900;
    /* 设置选中状态的背景颜色为橘色 */
    color: white;
}

.corp-head-div {
    width: 40%;
}

// .corp-head-div-p {
//     width: 20%;
// }

.van-toast__text {
    font-size: 0.48rem;
    /* 修改为你想要的字体大小 */
    padding: 10px;
}

.corp-head-div-t {
    //width: 50%;
    display: flex;
    margin-bottom: 20px;
    justify-content: space-between;
}

.goods-info-corp {
    margin-top: 10px;
    background-color: #f2f2f2;
    padding: 0 10px 10px 10px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-wrap: wrap;
}

.head-input-div-c {
    display: flex;
    width: 100%;
    align-items: center;
    position: relative;
    font-size: 20px;
    margin-bottom: 20px;
}

.head-input-div-i {
    display: flex;
    width: 100%;
    align-items: center;
    position: relative;
    font-size: 20px;
    margin-bottom: 20px;
    padding-bottom: 10px;
    margin-top: 20px;
}

.popup-input-div {
    display: flex;
    width: 90%;
    align-items: center;
    position: relative;
    font-size: 20px;
    margin-bottom: 20px;
    padding-bottom: 10px;
    margin-top: 20px;
}

.list-data {
    display: flex;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 10px;
}

.list-data-div {
    padding-right: 3px;
    text-align: left;
    font-size: 18px;
}

.list-data-div-a {
    padding-right: 3px;
    text-align: left;
    font-size: 14px;
}

.hidden {
    display: none;
}

.right-button {
    height: 20%;
    width: 90%;
    padding: 0 1px;
}

.out-button {
    // height: 20%;
    width: 45%;
    height: 60px;
    line-height: 60px;
    margin-bottom: 30px;
    //padding: 10px 10px;
}

.top-button {
    background-color: #ff976a;
    height: 60px;
    line-height: 60px;
    border-radius: 5px;
    color: #fff;
    width: 150px;
    border: 1px solid #ff976a;
}

.find-button {
    background-color: #000;
    height: 40px;
    line-height: 40px;
    border-radius: 5px;
    color: #fff;
    width: 120px;
    border: 1px solid #000;
}

.find-button-b {
    background-color: #ff976a;
    height: 40px;
    line-height: 40px;
    border-radius: 5px;
    color: #fff;
    width: 120px;
    border: 1px solid #ff976a;
}

.left-button {
    margin-right: 60px;
    height: 50px;
    line-height: 50px;
    width: 110px;
}


.van-dialog__message {
    font-size: 0.32rem;
}

.van-nav-bar__title {
    font-size: 0.32rem;
}

// th {
//     text-align: center; 
//     width: calc(100vw - 5px);
//     background-color: rgb(242, 242, 242); 
//     border-right: 1px solid #ccc; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
//     padding: 10px 0;
// }
.table-wrapper {
    overflow-x: auto;
    background-color: white;
}


.table {
    width: 150%;
    border-collapse: collapse;
    font-size: 14px;
    overflow: auto;
}

.table2 {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
    overflow: auto;
}

.table th,
.table td {
    padding: 10px 12px;
    text-align: left;
    border-bottom: 1px solid #ddd;
}

.table-header th {
    position: sticky;
    top: 0;
    background-color: #fff;
    z-index: 1;
}

.table th {
    background-color: #f5f5f5;
    font-weight: bold;
}

.table2 th,
.table2 td {
    padding: 10px 12px;
    text-align: left;
    border-bottom: 1px solid #ddd;
}

.table2 th {
    background-color: #f5f5f5;
    font-weight: bold;
}

// .table tr:hover {
//     background-color: #ede368;
// }

.keyboard {
    /*兼容低版本安卓css*/
    width: 5rem;
    //margin-top: 10px;
    float: right;
}

.cutMeter {
    height: 101px;
    width: 2.5rem;
    font-size: 0.8rem;
    padding: 5px;
    background-color: #ededed;
    border: none;
    text-align: center;
}

.Cqday {
    height: 101px;
    width: 2.4rem;
    padding: 5px;
    background-color: #ededed;
    border: none;
    text-align: center;
    color: red;
    font-size: 30px;
}

.crop-bottom {
    // position: fixed;
    // bottom: 0;
    // left: 0;
    width: 100%;
    justify-content: flex-start;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    //background-color: #fff;
    //flex-direction: column;
}

.key {
    width: calc(33.33% - 5px);
    height: 75px;
    font-size: 0.4rem;
    font-weight: bold;
    float: left;
    margin-right: 5px;
    margin-bottom: 5px;
    box-sizing: border-box;
    text-align: center;
    background-color: #f0f0f0;
    border: 1px solid #ccc;
    border-radius: 3px;
    padding: 10px;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
    transition: background-color 0.3s, transform 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
    /* 水平居中 */
}

.selected-item {
    border: 2px solid red;
    background-color: #ede368;
}

.loading-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99999;
}

.loading-mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: transparent;
    z-index: -1;
}

.loading-content {
    display: flex;
    justify-content: center;
    align-items: center;
}

.mix-div {
    margin-left: 10px;
    font-size: 28px;
    margin: 10px;
    text-align: right;
    display: flex
}

.gongxu {
    font-size: 28px;
}

.layui-btn {
    background-color: #000;
    height: 30px;
    line-height: 30px;
    padding: 10px 20px;
    border-radius: 5px;
}

.tool {
    display: flex;
    justify-content: space-between;
    height: 100px;
    padding: 10px;
    align-items: center;
    color: #fff;

}

.tool>div {
    float: left;
}

.available span {
    font-size: 14px;
}

.next-month span {
    font-size: 14px;
}

.prev-month span {
    font-size: 14px;
}
</style>